import React from 'react';
import { ReceptionDetail } from './components/containers/ReceptionDetail';

/**
 * Página de detalle de una recepción individual
 */
const ViewReception = () => <ReceptionDetail />;

export default ViewReception;

